(function () {
    'use strict';

    function accountManagerDataService($http) {

        function loadAll() {
            return $http.get('[BuildifyApiHost]/api/accountmanagers').then(function (response) {
                return response.data;
            });
        };

        function loadProjectsForEntity(entityId) {
            return $http.get('[BuildifyApiHost]/api/' + entityId + '/contractorprojects?pageSize=1024').then(function (response) {
                return response.data;
            });
        };

        function loadWorkflowsForEntity(entityId) {
            return $http.get('[BuildifyApiHost]/api/' + entityId + '/workflows?pageSize=1024').then(function (response) {
                return response.data;
            });
        };

        return {
            loadAll: loadAll,
            loadProjectsForEntity: loadProjectsForEntity,
            loadWorkflowsForEntity: loadWorkflowsForEntity
        }
    }

    accountManagerDataService.$inject = ['$http'];

    angular.module('ecap.crm').service('accountManagerDataService', accountManagerDataService);
})();
